

const ProgressHome = (progress) => {


    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <progress id="file" value={progress.value} max="100" style={{marginTop:'25px',position:"fixed"}}></progress>
        <span style={{position:"fixed"}}>Cargando...</span>
      </div>
    );
  };
  export default ProgressHome;